import { Sidebar } from '@futrli/ui-components';
import Typography from 'carbon-react/lib/components/typography';
import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';

interface Props {
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
}

export const ImportAssumptionsAdvisorContainer = ({ children, isOpen, onClose }: Props) => {
  const intl = useIntl();

  return (
    <Sidebar
      open={isOpen}
      onCancel={onClose}
      aria-label={intl.formatMessage({
        id: 'predict.import_assumptions_from_advisor',
        defaultMessage: 'Import assumptions from Advisor'
      })}
      header={
        <Typography variant="h2" fontWeight="700">
          {intl.formatMessage({
            id: 'predict.import_assumptions_from_advisor',
            defaultMessage: 'Import assumptions from Advisor'
          })}
        </Typography>
      }
      size="medium-large"
    >
      {children}
    </Sidebar>
  );
};
